import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateMarkAsPaidPayments } from 'modules/_common/api';

export const useMutationMarkAsPaidInvoice = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  return useMutation(updateMarkAsPaidPayments, {
    onSuccess: () => {
      successToast();
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_ACCOMMODATION_INVOICES);
      queryClient.refetchQueries(QUERY_KEYS.INVOICES);
    },
    onError: (error: AxiosError) => {
      const errorMessage = error.response?.data as { ErrorDescription: string };
      errorToast(errorMessage?.ErrorDescription);
    },
  });
};
